import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";
import Select from "Components/Admin/Form/Select";

import * as S from "./styles";

const ConversationModal = ({
  projectId,
  setOpenModal,
  getProjectConversations,
}) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [userOptions, setSponsorOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => getAvailableConversations(), []);

  const getAvailableConversations = () => {
    api
      .post("/projects/available-conversations", { project_id: projectId })
      .then((response) => {
        const users = response.data?.available_users;

        const options = users?.map((sponsor) => ({
          label: sponsor?.full_name,
          value: sponsor.id,
        }));

        setSponsorOptions(options);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const submit = async (data) => {
    if (!selectedUser) return;

    setLoading(true);

    try {
      await api.post("/projects/conversations/create", {
        ...data,
        project_id: projectId,
        target_user_id: selectedUser?.value,
      });

      setLoading(false);

      showNotification("success", "Sucesso!", "Conversa criada com sucesso!");

      setOpenModal(null);
      getProjectConversations(projectId);
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <Form onSubmit={submit}>
          <S.Section>
            <span>Criar Conversa</span>
            <hr />
          </S.Section>

          <Select
            name="sponsor_id"
            label="Usuário"
            options={userOptions}
            placeholder="Selecione um Usuário"
            value={selectedUser}
            onChange={setSelectedUser}
            maxWidth="100%"
            required
          />

          {!userOptions.length ? <span>Nenhum usuário disponível.</span> : null}

          <S.Buttons>
            <Button
              type="button"
              outline
              text="Fechar"
              disabled={loading}
              onClick={() => setOpenModal(null)}
            />

            <Button type="submit" text="Criar" disabled={loading} />
          </S.Buttons>
        </Form>
      </S.Modal>
    </S.Wrapper>
  );
};

export default ConversationModal;
